/// <reference types="vinxi/types/client" />

import { StartClient } from '@tanstack/react-start';
import { hydrateRoot } from 'react-dom/client';

import { getAnalytics } from '#/lib/analytics';
import { createRouter } from '#/router';
import hubspot from '#/vendors/hubspot';
import rb2b from '#/vendors/rb2b';

const router = createRouter();

try {
  // We want to capture the initial pageview, and then any subsequent pageviews
  // by listening to the router history.
  const analytics = getAnalytics();
  analytics.capture('$pageview', { $current_url: window.location.href });
  let previousHref = window.location.href;
  rb2b.initialize();

  router.history.subscribe((opts) => {
    const href = `${window.location.origin}${opts.location.pathname}`;

    try {
      if (previousHref !== href) {
        analytics.capture('$pageleave', { $current_url: previousHref });
      }

      analytics.capture('$pageview', { $current_url: href });
      previousHref = href;
    } catch (error) {
      // do nothing
    }

    try {
      // We need to wait for the page to load before refreshing the hubspot widget
      // because it's not available immediately after the page loads.
      hubspot.conversations.close();
      setTimeout(() => {
        hubspot.conversations.refresh({ openToNewThread: true });
      }, 1000);
    } catch (error) {
      analytics.captureException(error, { reason: 'hubspot.refresh' });
    }

    try {
      // We need to refresh the RB2B script when the page is changed.
      rb2b.refresh();
    } catch (error) {
      analytics.captureException(error, { reason: 'rb2b.refresh' });
    }
  });
} catch (error) {
  // do nothing
}

hydrateRoot(document, <StartClient router={router} />);
